import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import { getOrderFormRemoveGiftOptionLoadingSelector, getOutstandingBalanceSelector } from '../../redux/reducers/order-form/orderFormSelector';
import { giftCardsSelector } from '../../redux/reducers/payment/giftCardReducer';
import {
  getGiftCardApplyGiftPaymentFailedSelector,
  getGiftCardErrorMessageSelector,
  getGiftCardFormSubmitFailedSelector,
  getGiftCardIsLoadingSelector,
} from '../../redux/reducers/payment/giftCardSelector';
import { isZeroAmount } from '../../utils';
import { APPLY_GIFT_CARD_FORM_ID } from '../../utils/form/configs/giftOptions';

const fieldValueSelector = (state: RootState) => state.form?.[APPLY_GIFT_CARD_FORM_ID]?.values;
const giftCardsListSelector =
  (state: RootState, renderingContext: string) => giftCardsSelector(state, renderingContext).usedGiftCards;

const applyGiftCardState = createSelector(
  [
    getGiftCardApplyGiftPaymentFailedSelector,
    getGiftCardErrorMessageSelector,
    getGiftCardFormSubmitFailedSelector,
    giftCardsListSelector,
    getGiftCardIsLoadingSelector,
    getOutstandingBalanceSelector,
    getOrderFormRemoveGiftOptionLoadingSelector,
    fieldValueSelector,
  ],
  (
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    giftCardsList,
    isLoading,
    outstandingBalance,
    removeGiftOptionLoading,
    values,
  ) => ({
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    giftCardsList,
    isGiftCardAmountZero: isZeroAmount(outstandingBalance ?? ''),
    isLoading,
    outstandingBalance,
    removeGiftOptionLoading,
    values,
  }),
);

export default applyGiftCardState;
